document.addEventListener('DOMContentLoaded', function () {
  var timers = document.querySelectorAll('[data-tw-countdown-time]');
  if (!timers.length) return;

  function msUntilMidnight() {
    var now = new Date();
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    return midnight - now;
  }

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function tick() {
    var totalSeconds = Math.max(0, Math.floor(msUntilMidnight() / 1000));
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var display = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);

    timers.forEach(function (timer) {
      timer.textContent = display;
    });
  }

  tick();
  setInterval(tick, 1000);
});
